import clsx from "clsx";
import { Search, X } from "react-bootstrap-icons";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "@/components/ui/input-group";
import styles from "./SearchInput.module.scss";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  size?: "sm" | "lg";
  className?: string;
  fixed?: boolean;
}

const SearchInput = ({
  value,
  onChange,
  placeholder = "Search Documents",
  size = "sm",
  className = "",
  fixed = false,
}: SearchInputProps) => {
  return (
    <InputGroup
      className={clsx(
        styles.searchInput,
        className,
        fixed && styles.fixed,
        size === "sm" && styles.sizeSm,
        size === "lg" && styles.sizeLg,
      )}
    >
      <InputGroupAddon
        align="inline-start"
        className={styles.searchIconContainer}
      >
        <Search size={11} className={styles.searchIcon} />
      </InputGroupAddon>
      <InputGroupInput
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={clsx(styles.input, value && styles.hasValue)}
      />
      {value && (
        <InputGroupAddon align="inline-end">
          <InputGroupButton
            variant="ghost"
            onClick={() => onChange("")}
            aria-label="Clear search"
            className={styles.clearBtn}
          >
            <X size={10} className={styles.clearBtnIcon} />
          </InputGroupButton>
        </InputGroupAddon>
      )}
    </InputGroup>
  );
};

export default SearchInput;
